<div class="modal-header justify-content-between">
  <h4 class="mb-0">Change My Password</h4>
  <button class="close-button" (click)="cancel()">×</button>
</div>
<div class="subtitle">Enter your new password for your IllumLive account.</div>
<form [formGroup]="passwordForm" class="password-form">
  <div class="form-group">
    <label for="currpwd">Current Password</label>
    <input type="password" id="currpwd" placeholder="Current Password" class="form-control" formControlName="currpwd"
      required />
    </div>
    <div class="form-group">
      <label for="newpwd">New Password</label>
      <input type="password" id="newpwd" placeholder="New Password" class="form-control" formControlName="newpwd"
        required />
      </div>
      <div class="form-group">
        <label for="confirmnewpwd">Confirm New Password</label>
        <input type="password" id="confirmnewpwd" placeholder="Confirm New Password" class="form-control"
          formControlName="confirmnewpwd" required />
        </div>
        @if (showError()) {
          <div class="alert alert-danger" role="alert">
            {{ error }}
          </div>
        }
        @if (errorMessage) {
          <div class="alert alert-danger">
            {{ errorMessage }}
          </div>
        }
        <div class="form-actions">
          <button class="btn btn-primary" type="button" [disabled]="error" (click)="save()">Save</button>
          <button class="btn btn-secondary" type="button" (click)="cancel()">Close</button>
        </div>
      </form>

      <!-- Success Modal Template -->
      <ng-template #successModal let-modal>
        <div class="modal-header success-header">
          <h4 class="modal-title">Success</h4>
        </div>
        <div class="modal-body">
          <p>{{ successMessage }}</p>
        </div>
        <div class="modal-footer success-footer">
          <button class="btn btn-primary" (click)="modal.close()">OK</button>
        </div>
      </ng-template>